import { Anchor, Text } from "@mantine/core";
import type { Reference } from "../lib/transport";

/** "[1,2]" beside a method: each number links to its paper (or to the References page when it has no link).
 *  Nothing when there are no papers. Put it beside a checkbox, not inside its label (a click would toggle it). */
export function RefLinks({ refs, size = "sm" }: { refs: Reference[]; size?: "xs" | "sm" }) {
  if (!refs.length) return null;
  return (
    <Text span size={size} ml={4} c="dimmed" data-testid="ref-links" title="The paper(s) this is based on - see References">
      [{refs.map((r, i) => (
        <span key={r.key}>
          {i > 0 && ","}
          <Anchor href={r.url || "/references"} target={r.url ? "_blank" : undefined} rel="noopener noreferrer" size={size}>
            {r.number}
          </Anchor>
        </span>
      ))}]
    </Text>
  );
}
